import React from 'react';
import styled from 'styled-components';
import {Colors, FontStyles} from "../constants";

const _textInput = ({id, type, className, label, autoComplete, value, onChange}) => (
    <div className={className}>
        <span>{label}</span><br/>
        {type === 'textarea' ? <textarea onChange={onChange} id={id} autoComplete={autoComplete}>{value}</textarea> :
            <input onChange={onChange} id={id} type={type || 'text'} autoComplete={autoComplete} value={value}/>}
    </div>
);

export const TextInput = styled(_textInput)`
    color: ${props => props.outlineColor || Colors.button};
    > span {
    ${props => props.labelStyle}
    }
    > input, textarea {
    ${props => props.inputStyle || FontStyles.input}; 
    height: ${props => props.height || '50px'};
    width: ${props => props.width || '242px'};
    background-color: ${props => props.bgColor || 'white'};
    border: 1px solid ${props => props.outlineColor || Colors.button};
    padding: 0 10px 0 10px;
    margin-top: 6px;
    outline: none; 
    }
    > textarea {
    padding: 10px 10px 10px 10px;
    resize: none;
    }
    ${props => props.style};
`;

export const LightTextInput = styled(TextInput)`
    ${FontStyles.inputLight};
    > input {
    ${FontStyles.inputLight};
    border: 1px solid ${props => props.outlineColor || 'white'};
    background-color: transparent;
    }
`;